import React, {
    useState,
    useEffect
} from 'react';
import {
    useDispatch
} from 'react-redux';
import { useParams } from 'react-router-dom';
// import { useHistory } from 'react-router';

import AdminLayout from '../../../views/layout/adminpage';
import PageHeader from '../../../../widget/pageheader';
import Table from './table2nd';

import { getEmaterialstocksByid } from '../../../../../store/actions/ematerialstocks_action';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faSignInAlt, faListUl, faCartArrowDown, faUser, faBell, faHeart, faSignOutAlt, faCogs, faUsers, faMoneyBillWave, faShippingFast, faEnvelopeOpenText, faTachometerAlt, faChessQueen, faShoppingCart, faExchangeAlt, faMapPin, faClock, faMapMarkedAlt, faDollyFlatbed } from '@fortawesome/free-solid-svg-icons';
import { faHandshake } from '@fortawesome/free-regular-svg-icons';
import {
    faAddressCard
} from '@fortawesome/free-regular-svg-icons';

library.add(faHome, faSignInAlt, faListUl, faCartArrowDown, faUser, faBell, faHeart, faSignOutAlt, faCogs, faUsers, faMoneyBillWave, faShippingFast, faEnvelopeOpenText, faTachometerAlt, faChessQueen, faShoppingCart, faExchangeAlt, faAddressCard, faMapPin, faClock, faMapMarkedAlt, faDollyFlatbed, faHandshake)


const EditMaterialSecond = (props) => {
    const params = useParams();
    const dispatch = useDispatch();
    // const history = useHistory();
    // console.log(props, "<<<<<<Props props")
    // console.log(params, "<<<<<<params")

    const [pagename] = useState('Edit Gallery');
    const [loadingtable, loadingtableHandler] = useState(false);
    const [addnew] = useState(false);
    const [refresh] = useState(false);
    const [uploadfile] = useState(false);
    const [downloadfile] = useState(false);
    const [breadcrumb] = useState([
        {
            name: 'Dashboard',
            linkTo: '/admin/dashboard',
            public: true,
            faicons: faHome
        },
        {
            name: 'Stock',
            linkTo: '/admin/stock',
            public: true
        },
        {
            name: 'Goods',
            linkTo: '/admin/goods',
            public: true
        },
        {
            name: 'Material',
            linkTo: '/admin/material',
            public: true
        },
        {
            name: 'Material Stocks',
            linkTo: `/admin/material/editdata/${params.id}`,
            public: true
        },
        {
            name: 'Material Stocks Single',
            linkTo: `${props.location.pathname}`,
            public: true
        },
        {
            name: pagename,
            linkTo: '',
            public: true
        }
    ]);

    const [dataselected, dataselectedHandler] = useState();
    const [editformdatastatus] = useState(true);

    const clickHandler = (link) => {
        props.history.push(link);
    }

    useEffect(() => {
        let mounted = true;
        const abortController = new AbortController();
        const DataselectedCheck = async () => {
            try {
                const id = await params.id;
                let alldata = await dispatch(getEmaterialstocksByid(id), { signal: abortController.signal });
                let selectedata = await alldata.payload.docs[0].material.filter(data => data._id === params.nextid);
                if (mounted) {
                    dataselectedHandler(selectedata[0]);
                } 
            } catch (error) {

            }
        }
        DataselectedCheck();
        return () => {
            mounted = false;
            abortController.abort();
        }
    }, [dispatch]);

    // console.log(dataselected, "<<<<<<<Data selected")
    return (
        <AdminLayout>
            <div className="masterDashboard">
                <div className="masterDashboardContainer">
                    <div className="containerfluid">
                        <div className="pagetitlebox">
                            <PageHeader
                                {...props}
                                addnew={addnew}
                                refresh={refresh}
                                uploadfile={uploadfile}
                                downloadfile={downloadfile}
                                pagename={pagename}
                                breadcrumb={breadcrumb}
                                clickHandler={clickHandler}
                            />
                        </div>
                        <div className="row">
                            <div className="col-md-12 pl0 pr0">
                                {
                                    loadingtable ?
                                        <div className="tableloading">
                                            <div className="lds-ripple"><div></div><div></div></div>
                                        </div>
                                        :
                                        dataselected ?
                                            <div className="card">
                                                <div className="cardTitle verticalCenter">
                                                    <span>Please edit the information below</span>
                                                </div>
                                                <Table
                                                    {...props}
                                                    dataselected={dataselected}
                                                    editformdatastatus={editformdatastatus}
                                                    loadingtableHandler={loadingtableHandler}
                                                />
                                            </div>
                                            : null

                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
};

export default EditMaterialSecond;